import { render, staticRenderFns } from "./Etusivu.vue?vue&type=template&id=234287bb&scoped=true"
import script from "./Etusivu.vue?vue&type=script&lang=js"
export * from "./Etusivu.vue?vue&type=script&lang=js"
import style0 from "./Etusivu.vue?vue&type=style&index=0&id=234287bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234287bb",
  null
  
)

export default component.exports